import {
  ImageScaleView,
  MaskView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import gsap from 'gsap';

export class CardsPack extends View {
  private image: ImageScaleView;

  constructor(opts?: ViewOpts) {
    super({
      ...opts,
      width: 242,
      height: 353,
    });

    this.image = new ImageScaleView({
      superview: this,
      scaleMethod: 'contain',
      width: 242,
      height: 353,
      x: this.style.width / 2,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });
  }

  public setup(args: { tier: number }) {
    this.image.updateOpts({
      image: `assets/ui/cards/popupCardsPackReward/pack${args.tier}.png`,
      scaleMethod: 'contain',
      centerOnOrigin: true,
    });
  }

  public async open() {
    const offsetBot = 50;

    const maskBottom = new MaskView({
      superview: this,
      mask: 'assets/ui/cards/popupCardsPackReward/pack_mask_bot.png',
      width: 242,
      height: 353,
      x: this.style.width / 2,
      y: this.style.height / 2 + offsetBot,
      centerOnOrigin: true,
    });

    this.image.updateOpts({
      superview: maskBottom,
      x: this.style.width / 2,
      y: this.style.height / 2 - offsetBot,
    });

    const offsetTop = -250;

    const maskTop = new MaskView({
      superview: this,
      mask: 'assets/ui/cards/popupCardsPackReward/pack_mask_top.png',
      width: 242,
      height: 353,
      x: this.style.width / 2,
      y: this.style.height / 2 + offsetTop,
      centerOnOrigin: true,
    });

    const top = new ImageScaleView({
      superview: maskTop,
      scaleMethod: 'contain',
      image: this.image.getImage(),
      width: 242,
      height: 353,
      x: this.style.width / 2,
      y: this.style.height / 2 - offsetTop,
      centerOnOrigin: true,
    });

    gsap.to(maskTop.style, {
      offsetX: 400,
      r: 2,
      duration: 0.6,
      ease: 'quad.inOut',
    });

    await gsap.to(maskTop.style, {
      offsetY: -300,
      duration: 0.3,
      ease: 'sine.in',
    });

    await gsap.to(maskTop.style, {
      offsetY: 100,
      opacity: 0,
      duration: 0.3,
      ease: 'sine.in',
    });
  }
}
